createDataModel